import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async getVideo({ dispatch, commit }, { uuid }) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      this.isLoading = true;
      const { data } = await request.get(`/videos/${uuid}`);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('setVideo', {
        video: data.video,
      });

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },

  async updateVideo({ dispatch, commit }, { uuid, video }) {
    try {
      const response1 = await request.put(`/videos/${uuid}`, video);

      if (response1.data.error) {
        throw Error('Server-side validation failed');
      }

      const response2 = await request.get(`/videos/${uuid}`);

      if (response2.data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('updateVideo', {
        video: response2.data.video,
      });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
